import RegisterEmailLookup from 'components/Register/RegisterEmailLookup/RegisterEmailLookup';

export default RegisterEmailLookup;
